module.exports = __webpack_public_path__ + "img/Home-05.f7cc8132.svg";